import { useState, useEffect } from "react";
import { useUserStore } from "../../store/userStore.js";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  Modal,
  Table,
  ConfigProvider,
  Select,
  Input,
  DatePicker,
  Pagination,
  Popconfirm,
  Popover,
  Button,
} from "antd";


import images from "../../assets";
import PrimaryButton from "../button/primarybutton";
import CustomizeColumn from "../customizecolumns/customizecolumns";
import AdvancedFilter from "../advancedfilter/advancedfilter";

const { RangePicker } = DatePicker;

export default function DeleteUserListData() {
  const {
    users,
    userCount,
    maleUserCount,
    femaleUserCount,
    isLoading,
    getUsers,
    updateUsersStatus,
  } = useUserStore();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCustomizeModalOpen, setIsCustomizeModalOpen] = useState(false);

  const [pageNo, setPageNo] = useState(1);

  const [updateStatus, setUpdateStatus] = useState("");
  const [filters, setFilters] = useState({
    size: 10,
    from: 0,
    sort: "desc",
    gender: "",
    planType: "",
    keyword: "",
    fromDate: "",
    toDate: "",
    photoStatus: "",
    profileDescStatus: "",
    matchDescStatus: "",
    documentStatus: "",
    countryStatus: "",
    dateOfBirthStatus: "",
    genderStatus: "",
    ageMin: "",
    ageMax: "",
    profileCompletenessMin: "",
    profileCompletenessMax: "",
    maritalStatus: null,
    status: null,
    country: null,
    regSource: null,
  });

  const [customDateRange, setCustomDateRange] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const predefinedDateRanges = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 7 Days", value: "last7days" },
    { label: "Last 1 Month", value: "last1month" },
    { label: "Last 3 Months", value: "last3months" },
    { label: "Last 6 Months", value: "last6months" },
    { label: "Last 365 Days", value: "last365days" },
  ];

  useEffect(() => {
    fetchUsers();
  }, [filters]);

  const fetchUsers = async () => {
    const payload = { ...filters, status: "delete" };
    getUsers(payload);
  };

  const handlePageChange = async (pageNumber) => {
    setPageNo(pageNumber);
    setFilters({ ...filters, from: (pageNumber - 1) * filters?.size });
  };

  const handleReset = () => {
    setFilters({
      size: 10,
      from: 0,
      sort: "desc",
      gender: "",
      planType: "",
      keyword: "",
      fromDate: "",
      toDate: "",
      photoStatus: "",
      profileDescStatus: "",
      matchDescStatus: "",
      documentStatus: "",
      countryStatus: "",
      dateOfBirthStatus: "",
      genderStatus: "",
      ageMin: "",
      ageMax: "",
      profileCompletenessMin: "",
      profileCompletenessMax: "",
      maritalStatus: null,
      status: null,
      country: null,
      regSource: null,
    });
    setSelectedRowKeys([]);

    handleCancel();
  };

  const handleSearch = () => {
    handleCancel();
    fetchUsers();
  };

  const handleUpdateMultiple = async () => {
    if (selectedRowKeys.length > 0) {
      const payload = {
        usernames: selectedRowKeys,
        status: updateStatus,
      };
      updateUsersStatus(payload, () => {
        setUpdateStatus(null);
        setTimeout(() => {
          fetchUsers();
        }, 1000);
      });
    }
  };
  const handleUpdateStatus = async (username, status) => {
    const payload = {
      usernames: [username],
      status,
    };
    updateUsersStatus(payload, () => {
      setUpdateStatus(null);
      fetchUsers();
    });
  };

  const hasSelected = selectedRowKeys.length > 0;

  const handleRowSelection = (record) => {
    const newSelectedRowKeys = selectedRowKeys.includes(record.username)
      ? selectedRowKeys.filter((username) => username !== record.username)
      : [...selectedRowKeys, record.username];
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const allRowKeys = users.map((record) => record.username);
      setSelectedRowKeys(allRowKeys);
    } else {
      setSelectedRowKeys([]);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const showModal2 = () => {
    setIsCustomizeModalOpen(true);
  };
  const handleCancel2 = () => {
    setIsCustomizeModalOpen(false);
  };

  const calculateDateRange = (rangeValue) => {
    const now = moment();
    let fromDate = null;
    let toDate = now.endOf("day").format("YYYY-MM-DD");

    switch (rangeValue) {
      case "today":
        fromDate = now.clone().startOf("day").format("YYYY-MM-DD");
        toDate = now.clone().endOf("day").format("YYYY-MM-DD");
        break;
      case "yesterday":
        fromDate = now
          .clone()
          .subtract(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD");
        toDate = now
          .clone()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD");
        break;
      case "last7days":
        fromDate = now
          .clone()
          .subtract(7, "days")
          .startOf("day")
          .format("YYYY-MM-DD");
        break;
      case "last1month":
        fromDate = now
          .clone()
          .subtract(1, "month")
          .startOf("day")
          .format("YYYY-MM-DD");
        break;
      case "last3months":
        fromDate = now
          .clone()
          .subtract(3, "months")
          .startOf("day")
          .format("YYYY-MM-DD");
        break;
      case "last6months":
        fromDate = now
          .clone()
          .subtract(6, "months")
          .startOf("day")
          .format("YYYY-MM-DD");
        break;
      case "last365days":
        fromDate = now
          .clone()
          .subtract(365, "days")
          .startOf("day")
          .format("YYYY-MM-DD");
        break;
      default:
        break;
    }

    return { fromDate, toDate };
  };

  const handleRangeSelection = (value) => {
    const { fromDate, toDate } = calculateDateRange(value);
    setFilters({ ...filters, fromDate, toDate });
    setCustomDateRange([]);
    setDropdownVisible(false);
  };

  const handleCustomDateApply = () => {
    if (customDateRange?.length === 2) {
      setFilters({
        ...filters,
        fromDate: customDateRange[0].format("YYYY-MM-DD"),
        toDate: customDateRange[1].format("YYYY-MM-DD"),
      });
    } else {
      setFilters({
        ...filters,
        fromDate: "",
        toDate: "",
      });
    }
    setDropdownVisible(false);
  };

  const dropdownContent = (
    <div className="flex flex-col gap-2 p-3 bg-white rounded">
      {predefinedDateRanges.map((range) => (
        <div
          key={range.value}
          className="cursor-pointer hover:bg-gray-200 p-2 rounded"
          onClick={() => handleRangeSelection(range.value)}
        >
          {range.label}
        </div>
      ))}
      <div className="border-t pt-2 mt-2">
        <RangePicker
          onChange={(dates) => setCustomDateRange(dates)}
          value={customDateRange}
        />
        <div className="flex justify-end gap-2 mt-2">
          <Button type="primary" size="small" onClick={handleCustomDateApply}>
            Apply
          </Button>
          <Button size="small" onClick={() => setDropdownVisible(false)}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );

  const columns = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedRowKeys.length === users.length && users.length > 0}
          indeterminate={
            selectedRowKeys.length > 0 && selectedRowKeys.length < users.length
          }
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      fixed: "left",
      width: 50,
      key: "select",
      render: (_, record) => (
        <input
          type="checkbox"
          checked={selectedRowKeys.includes(record.username)}
          onChange={() => handleRowSelection(record)}
        />
      ),
    },
    {
      title: "#",
      width: 80,
      render: (text, record, index) =>
        (pageNo - 1) * filters?.size + (index + 1),
      key: "2",
    },
    {
      title: "Photo",
      width: 120,
      render: (text, record) => (
        <img
          src={record.profilePicture}
          className="h-[48px] w-[48px] rounded-xl object-cover"
          alt="pp"
        />
      ),
      key: "2",
    },
    {
      title: "User ID",
      key: "3",
      width: 130,
      render: (text, record) => `#${record.username}`,
      fixed: "left",
    },
    {
      title: "Name",
      key: "4",
      render: (text, record) => `${record.firstName} ${record.lastName}`,
      width: 200,
    },
    {
      title: "Gender",
      // sorter: true,
      render: (text, record) => record.gender,
      key: "5",
      width: 90,
    },
    {
      title: "Country",
      key: "6",
      render: (text, record) => record.country,
      width: 150,
    },
    {
      title: "Age",
      key: "7",
      render: (text, record) =>
        record.dateOfBirth
          ? moment(record.dateOfBirth).fromNow().split(" ")[0]
          : null,
      width: 70,
    },
    {
      title: "Marital Status",
      key: "8",
      render: (text, record) => (
        <div className="capitalize">
          {record?.maritalStatus === "neverMarried"
            ? "never married"
            : record?.maritalStatus}
        </div>
      ),
      width: 150,
    },
    {
      title: "Email",
      key: "9",
      render: (text, record) => record.email,
      width: 240,
    },
    {
      title: "Mobile No.",
      key: "10",
      render: (text, record) => record.phone,
      width: 150,
    },
    {
      title: "Registered Date",
      // sorter: true,
      render: (text, record) =>
        moment(record?.createdAt).format("DD MMMM, YYYY"),
      key: "12",
      width: 200,
    },
    {
      title: "Deleted Date",
      dataIndex: "deleteDate",
      sorter: true,
      // render: (name) => `${name.first} ${name.last}`,
      key: "12",
      width: 150,
    },
    {
      title: "Reg. Source",
      // sorter: true,
      // render: (name) => `${name.first} ${name.last}`,
      key: "13",
      width: 150,
    },
    {
      title: "Membership Status",
      key: "14",
      render: (text, record) =>
        record?.premiumStatus === "true" || record?.premiumStatus === true
          ? "Premium"
          : "Standard",
      width: 150,
    },
    {
      title: "Delete Reason",
      dataIndex: "deleteReason",
      key: "15",
      width: 150,
    },
    {
      title: "Action",
      key: "17",
      fixed: "right",
      width: 230,
      render: (text, record) => (
        <div className="flex flex-col gap-2 justify-center items-center">
          <div className="flex flex-row gap-2 items-center justify-center">
            <Link to={`/userprofileoverview/${record.username}`}>
              <img src={images.editIcon} alt="" />
            </Link>
            <img src={images.viewIcon} alt="" />
          </div>
          <div className="flex flex-row gap-2 items-center justify-center">
            <Popconfirm
              title="Delete user?"
              description="Are you sure you want to permanently delete this user?"
              onConfirm={() => handleUpdateStatus(record?.username, "delete")}
              okText="Yes"
              cancelText="No"
            >
              <PrimaryButton
                style={{
                  height: "25px",
                  fontSize: "12px",
                  background: "#F31260",
                  borderRadius: "4px",
                }}
                text="Permanently Delete"
              />
            </Popconfirm>
          </div>

          <div className="flex gap-2">
            <img src={images.messageBtn} alt="" />
            <Link to={`mailto:${record?.email}`} target="_blank">
              <img src={images.emailBtn} alt="" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="w-full flex flex-col justify-between pt-8">
        <div className="flex flex-col justify-between gap-4">
          <div>
            <div className="w-full justify-between items-center flex flex-row pr-4">
              <div className="w-full px-6 py-5 bg-white rounded-2xl border border-primary50 flex-col justify-center items-start gap-8 flex">
                <div className="self-stretch justify-start items-center gap-9 inline-flex">
                  <div className="justify-start items-center gap-4 flex">
                    <Select
                      showSearch
                      style={{
                        width: "156px",
                        height: 48,
                      }}
                      placeholder="Select Gender"
                      allowClear
                      options={[
                        {
                          value: "male",
                          label: "Male",
                        },
                        {
                          value: "female",
                          label: "Female",
                        },
                      ]}
                      onChange={(e) =>
                        setFilters({ ...filters, gender: e, from: 0 })
                      }
                      value={filters.gender || undefined}
                    />
                    <Input
                      style={{ height: 48, width: 327 }}
                      placeholder="Keywords"
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          keyword: e.target.value,
                          from: 0,
                        })
                      }
                      value={filters.keyword}
                    />
                    <Select
                      showSearch
                      style={{
                        width: "126px",
                        height: 48,
                      }}
                      placeholder="Plan Type"
                      options={[
                        {
                          value: "standard",
                          label: "Standard",
                        },
                        {
                          value: "premium",
                          label: "Premium",
                        },
                      ]}
                      onChange={(e) => setFilters({ ...filters, planType: e })}
                      value={filters.planType || undefined}
                    />
                    <Popover
                      content={dropdownContent}
                      trigger="click"
                      open={dropdownVisible}
                      onOpenChange={(visible) => setDropdownVisible(visible)}
                    >
                      <div className="bg-gray-100 border border-gray-300 rounded-lg p-3.5 w-max text-[#00000046] font-semibold cursor-pointer">
                        {filters.fromDate && filters.toDate ? (
                          <span className="flex gap-3">
                            From: {filters.fromDate} To: {filters.toDate}
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                setFilters({
                                  ...filters,
                                  fromDate: "",
                                  toDate: "",
                                });
                                setCustomDateRange([]);
                              }}
                              className="cursor-pointer"
                            >
                              X
                            </span>
                          </span>
                        ) : (
                          "Select Date Range"
                        )}
                      </div>
                    </Popover>
                  </div>
                  <div className="justify-start items-center gap-3 flex">
                    {/* <div
                    className=" bg-secondary rounded-lg justify-center items-center flex h-[42px] w-[42px] cursor-pointer"
                    onClick={handleSearch}
                  >
                    <img src={images.searchWhiteIcon} alt="search" />
                  </div> */}
                    <div
                      className="bg-[#f3f3fa] rounded-lg border border-primary50 justify-center items-center flex h-[42px] w-[42px] cursor-pointer"
                      onClick={handleReset}
                    >
                      <img src={images.syneIcon} alt="reset" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex-col justify-center items-end gap-4 inline-flex">
                <PrimaryButton
                  onClick={showModal}
                  style={{
                    width: "195px",
                    height: "40px",
                    fontSize: "16px",
                  }}
                  text={"Advanced Filter"}
                  iconalign="left"
                  icon={images.advanceFilterIcon}
                />
              </div>
            </div>
            <Modal
              width="80%"
              footer={null}
              closable={false}
              open={isModalOpen}
              onCancel={handleCancel}
            >
              <AdvancedFilter
                onClick={handleCancel}
                filters={filters}
                setFilters={setFilters}
                handleSearch={handleSearch}
                handleReset={handleReset}
              />
            </Modal>
            <Modal
              width="80%"
              footer={null}
              closable={false}
              open={isCustomizeModalOpen}
              onCancel={handleCancel2}
            >
              <CustomizeColumn onClick={handleCancel2} />
            </Modal>
          </div>
          <div className="flex gap-3">
            <div>
              <strong>Total Users:</strong> {userCount}
            </div>
            <div>
              <strong>Male Users:</strong> {maleUserCount}
            </div>
            <div>
              <strong>Female Users:</strong> {femaleUserCount}
            </div>
          </div>
          <div className="h-12 justify-between items-center flex pb-4">
            <div className="justify-start items-center gap-4 flex">
              <div className="justify-start items-center gap-2 flex">
                <div className="p-1 bg-[#b7eecf] rounded-[32px] justify-start items-center gap-2.5 flex">
                  <div className="w-5 h-5 relative">
                    <img src={images.selectCheckIcon} alt="check" />
                  </div>
                </div>
                <div className="text-[#222222] text-base font-normal  leading-normal">
                  {hasSelected ? `${selectedRowKeys.length}` : "0"} items
                  selected
                </div>
              </div>
              <div className="justify-between items-center flex gap-2">
                <Select
                  className="userlist-table"
                  showSearch
                  style={{ width: 160, height: "48px" }}
                  placeholder="Action"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  allowClear
                  options={[
                    {
                      value: "active",
                      label: "Active",
                    },
                    {
                      value: "suspended",
                      label: "Suspended",
                    },
                    {
                      value: "blocked",
                      label: "Blocked",
                    },
                    {
                      value: "deactivate",
                      label: "Deactivated",
                    },
                    {
                      value: "delete",
                      label: "Deleted",
                    },
                  ]}
                  disabled={selectedRowKeys?.length === 0}
                  onChange={(e) => setUpdateStatus(e)}
                  value={updateStatus || undefined}
                />
                <PrimaryButton
                  onClick={handleUpdateMultiple}
                  style={{
                    width: "125px",
                    height: "46px",
                    fontSize: "16px",
                  }}
                  disabled={!updateStatus}
                  text={"Update"}
                />
              </div>
            </div>
            <div className="justify-start items-center gap-2 flex pr-4">
              <PrimaryButton
                onClick={showModal2}
                style={{
                  width: "195px",
                  height: "46px",
                  fontSize: "16px",
                }}
                text={"Customize Columns"}
              />
              <Select
                className="userlist-table"
                showSearch
                style={{ width: 110, height: "48px" }}
                placeholder="Showing"
                value={filters.size}
                onChange={(e) => setFilters({ ...filters, size: e })}
              >
                <Select.Option value={10}>Show 10</Select.Option>
                <Select.Option value={20}>Show 20</Select.Option>
                <Select.Option value={50}>Show 50</Select.Option>
                <Select.Option value={100}>Show 100</Select.Option>
              </Select>
              <Select
                className="userlist-table"
                showSearch
                style={{ width: 100, height: "48px" }}
                placeholder="Sort by"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(e) => setFilters({ ...filters, sort: e })}
                value={filters.sort}
                options={[
                  {
                    value: "desc",
                    label: "Newest",
                  },
                  {
                    value: "asc",
                    label: "Oldest",
                  },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="w-full">
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#310048",
                  headerColor: "#ffffff",
                  cellFontSize: "14px",
                  headerSortHoverBg: "#310048",
                  headerSortActiveBg: "",
                },
              },
            }}
          >
            <Table
              className="user-list"
              bordered
              columns={columns}
              pagination={false}
              dataSource={users}
              scroll={{
                x: 1500,
                y: 600,
              }}
              loading={isLoading}
              rowKey={(record) => record.username}
            />
            <div className="py-5">
              <Pagination
                pageSize={filters.size}
                total={userCount}
                current={pageNo}
                showSizeChanger={false}
                onChange={handlePageChange}
              />
            </div>
          </ConfigProvider>
        </div>
      </div>
    </>
  );
}








